import React, { useCallback } from "react";
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material";
import logo from "../../icons/monsisra-logo.png";
import { useAppDispatch, useAppSelector } from "../../store";
import { setPreferencesPartial, setUseMonSisra } from "../../store/expertise/expertise.reducer";
import { Caption, Link, Title } from "./Texts";

export default function OutilTelemedecine() {
	const dispatch = useAppDispatch();

	const { preferences, useMonSisra } = useAppSelector((s) => ({
		preferences: s.expertise.preferences,
		useMonSisra: s.expertise.useMonSisra,
	}));

	const urlOutil = React.useMemo(() => preferences?.urlOutil, [preferences]);

	const setUrlOutilCb = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					urlOutil: e.target.value,
				})
			);
		},
		[dispatch]
	);

	const setUseMonSisraCb = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(setUseMonSisra(e.target.value === "true"));
		},
		[dispatch]
	);

	if (!preferences) return null;

	return (
		<Grid container direction={"column"} spacing={2}>
			<Grid item>
				<Title text={"Outil de télémédecine"} />
			</Grid>
			<Grid item>
				<FormControl component="fieldset">
					<RadioGroup value={useMonSisra} onChange={setUseMonSisraCb} name="radio-buttons-group">
						<FormControlLabel
							value={"true"}
							control={<Radio />}
							label={
								<Grid container alignItems={"center"} spacing={2}>
									<Grid item>Je souhaite recevoir et répondre à mes demandes via</Grid>
									<Grid item>
										<img src={logo} width={"125"} alt="Logo de MonSisra" />
									</Grid>
									<Grid item>
										<Link
											href="https://www.sante-ra.fr/monsisra/installer"
											text="(télécharger l'application sur www.monsisra.fr)"
										/>
									</Grid>
								</Grid>
							}
						/>
						<Grid container alignItems={"center"}>
							<Grid item>
								<FormControlLabel value={"false"} control={<Radio />} label="Je renseigne l'url d'un autre outil" />
							</Grid>
							<Grid item xs={true}>
								<TextField
									className={"input"}
									fullWidth
									variant={"standard"}
									error={!useMonSisra && !urlOutil}
									disabled={useMonSisra}
									sx={{
										backgroundColor: useMonSisra ? "#e6e6e6" : undefined,
									}}
									onChange={setUrlOutilCb}
									value={urlOutil ?? ""}
								/>
							</Grid>
						</Grid>
					</RadioGroup>
				</FormControl>
			</Grid>
			<Grid item>
				<Caption
					text={
						<Grid container spacing={0.5}>
							<Grid item>(contacter</Grid>
							<Grid item>
								<Link text="l'assistance SARA" href={"https://www.sante-ara.fr/contact/ "} />
							</Grid>
							<Grid item>pour plus d'informations)</Grid>
						</Grid>
					}
				/>
			</Grid>
		</Grid>
	);
}
